export enum DevicePlatform {
  ScreenCloudOS = "screencloudos",
  PIXI = "pixi",
}
